import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  informationIcon: {
    width: '16px',
    height: '16px',
    color: capitalDesignTokens.foundations.colors.gray800,
    marginRight: '4px'
  },
  fontWarningText: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall
  }
});
